import { ComponentProps, ReactNode } from "react";
import { createUseStyles } from "react-jss";
import clsx from "clsx";
import { theme } from "$utils/theme/bataillog";

type Props = {
  children?: ReactNode;
  contentClassName?: string;
};

function Paper({
  children,
  className = "",
  ref, // prevent to give a ref to a div
  ...props
}: Props & ComponentProps<"div">) {
  const classes = useStyles();
  return (
    <div className={clsx(classes.Paper, className)} {...props}>
      {children}
    </div>
  );
}

const useStyles = createUseStyles(() => ({
  Paper: {
    display: "flex",
    flex: 1,
    fontFamily: theme.font.workSans,
    border: `1px solid ${theme.color.gray2}`,
    color: theme.color.black,
    background: theme.color.white,
    borderRadius: 5,
    boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2)",
    padding: "8px",
  },
}));

export default Paper;
